// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"501673b3","364":"0ee8704e","379":"468d96b5","412":"468d96b5","873":"4fc58802","888":"85e771c5","907":"c3a0d8aa"}[chunkId] + ".chunk.css";
};